export default function({ state, commit, dispatch, rootState }, query) {
    return dispatch('get', {
        url: '/provider/' + query.provider + '/patient/' + query.patient + '/document',
        query: {
            document_type: 'facesheet,images,consentform'
        }
    }, {
        root: true
    })
    .then((response) => {
        return response
    })
    .catch((error) => console.error('Error loading history ', error))
}